export const environment = {
  production: true,
  api: 'https://api.harryhall.mysqldesigners.co.uk/api/',
  host: 'https://api.harryhall.mysqldesigners.co.uk/',
  getAddApiKey:'W_27C7CBCACA644AFCBCFFEACEEA1EDC'
};
